import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { projects } from "../assets/project";
import ProjectItem from "../components/projectItem";

function Projects() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="projects-page container">
      <div className="header">
        <Link to="/" className="link">
          {"<"} Volver al inicio
        </Link>
        <h2>Proyectos</h2>
      </div>

      <div className="project-list-page">
        {projects.map((pro) => (
          <ProjectItem
            key={pro.name}
            project={pro}
            classn={"project-item-page"}
          />
        ))}
      </div>
    </div>
  );
}

export default Projects;
